import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const REMITTANCE_SCHEMA = Object.freeze({
    SHOW: false,
    CREDIT_CARD_TYPES: null, // ''
  }),
  RECORD = generateSchema(REMITTANCE_SCHEMA),
  KEYS: any = generateKeys(REMITTANCE_SCHEMA);

export class Remittance extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get show(): boolean {
    return this.get(KEYS.SHOW);
  }

  get creditCardTypes(): string {
    return this.get(KEYS.CREDIT_CARD_TYPES);
  }
}
